module.exports = class ProductsListCtrl
  constructor: ->
    'ngInject'

  $onInit: ->
    @updateTable = @updateTable.bind(@)

  updateTable: ->
    @onRefresh()
